import { PropsWithChildren } from "react";
import CleBreadcrumbs from "../components/CleBreadcrumbs";
import CleComplianceNavbar from "../components/CleComplianceNavbar";
import HomeFooter from "@/components/layouts/HomeFooter";
import DelegationBanner from "@/components/delegation/DelegationBanner";

const MainLayout = ({ children }: PropsWithChildren) => {
  return (
    <div
      style={{ backgroundColor: "#F9FAFC" }}
      className=" min-vh-100 d-flex  flex-column"
    >
      <div className="sticky-top">
        <CleComplianceNavbar />
      </div>
      <DelegationBanner />
      <div className="container-xxl  p-4">
        <CleBreadcrumbs />
        {children}
      </div>
      <HomeFooter />
    </div>
  );
};

export default MainLayout;
